<template>
  <a-modal
    title="Məsul əməkdaş təyini"
    :footer="null"
    centered
    v-model="modalVisible"
  >
    <div>
      <label style="margin: 10px 0px; display: block">Tabeli qurum</label>
      <a-select
        v-model="selectedRepresentationId"
        style="width: 100%"
        placeholder="Zəhmət olmasa Tabeli qurum seçin"
        allowClear
      >
        <a-select-option
          v-for="(rep, index) in representations"
          :value="rep.id"
          :key="index"
          >{{ rep.name }}</a-select-option
        >
      </a-select>
    </div>

    <div>
      <label style="margin: 10px 0px; display: block">Məsul əməkdaş</label>
      <a-select
        v-model="selectedUserUUID"
        style="width: 100%"
        placeholder="Zəhmət olmasa Məsul əməkdaş seçin"
        allowClear
      >
        <a-select-option
          v-for="(rep, index) in controllers"
          :value="rep.uuid"
          :key="index"
          >{{ rep.firstName+' '+rep.lastName+' '+rep.fatherName }}</a-select-option
        >
      </a-select>
    </div>

    <div style="position: relative; height: 40px; margin-top: 10px">
      <a-button
        :disabled="!selectedUserUUID||!selectedRepresentationId"
        style="position: absolute; right: 0"
        type="primary"
        :loading="submitLoading"
        @click="setRepresentation"
      >
        Saxla</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
export default {
  name: "RepresentationModal",
  props: {
    visible: Boolean,
    problem: Object,
  },
  data() {
    return {
      modalVisible: null,
      submitLoading: false,
      representations: [],
      filesList: [],
      selectedRepresentationId: null,
      selectedRepresentation: null,
      selectedUserUUID:null,
      controllers:[]
    };
  },
  methods: {
    getRepresentations() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/representations",
        method: "GET",
        params: { parent: false },
      })
        .then((response) => {
          if (!response.data.error)
            this.representations = response.data.data.entities;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getControllers() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "users/controllers",
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error)
            this.controllers = response.data.data.entities;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setRepresentation() {
      if (!this.selectedRepresentationId) {
        this.$message.error("Nəzarətçi seçilməyib");
        return;
      }
      if (
        this.selectedRepresentation &&
        this.selectedRepresentationId === this.selectedRepresentation.id
      ) {
        return;
      }
      this.submitLoading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.problem.id +
          "/representation",
        method: "PATCH",
        data: {
          representation: { id: this.selectedRepresentationId },
          controllerUUID:this.selectedUserUUID
        },
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.$emit(
              "change",
              this.representations.find(
                (item) => item.id === this.selectedRepresentationId
              )
            );
            this.submitLoading = false;
            this.modalVisible = false;
          } else {
            this.$message.error(response.data.error.message);
            this.submitLoading = false;
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          this.submitLoading = false;
          console.log(err);
        });
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (newValue) {
        this.getRepresentations();
        this.getControllers();
      }
      if (!oldValue && newValue && this.problem) {
        this.selectedRepresentationId = this.problem.representation
          ? this.problem.representation.id
          : null;
        this.selectedUserUUID = this.problem.controller
          ? this.problem.controller.uuid
          : null;
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
